module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABBklEQVRIx2P4jw3Ub6pnSGOgFI0aTYnRPLk80XOiBQsEqWy0VafVvhv7gKbDRVgzWWXLZSk1WqxY7PXn124T3NDEb728teXSFr48PvKNXnpy6bdf39iz2OEibFls0w5M+/fv3+N3j5kzmMk0mjGd8eP3j5efXsbUv+DYAu0GbflKeTKNVqtVAwp++PYBUz9nNidFYQ0xGgg06jSonPggAQIU335lOy6DhAuFyY9GiFTdpjqgTWiyQoVCytXKFCU+iOy2y9scehwgqUWkSCRzaWb5unJKs8z9N/fhar7/+v7p+ydg4gMmQWDeoUJGb9rSdODmAWBqufni5rJTy5z6nEYL1YE3GgATmNc2/QN3zQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pk.png
// module id = 909
// module chunks = 0